<mat-form-field appearance="outline">
  <mat-label>Город</mat-label>
  <input matInput [formControl]="control" [matAutocomplete]="auto" />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayProperty"
    (optionSelected)="onSelect($event)"
  >
    <mat-option *ngFor="let city of filteredCities" [value]="city">
      {{ city.description }}
    </mat-option>
    <mat-option *ngIf="filteredCities?.length === 0" [value]="control.value">
      Создать {{ control.value }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
